import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { getCustomState, saveCustomState } from './LocalStorage';
import { setConfig } from '../datastore/actions/configActions';
import { SESSION_STATE } from './constants/AppConstants';
import configurations from '../config.json';

const Preload = () => {
  const dispatch = useDispatch();

  const session = useSelector((state) => state.session.session);
  const config = useSelector((state) => state.config.config);

  const sessionState = getCustomState(SESSION_STATE);

  useEffect(() => {
    if (!config.length) {
      dispatch(setConfig(configurations));
    }

    if (session && session !== sessionState) {
      saveCustomState(SESSION_STATE, session);
    }
  }, [session, sessionState]);

  return null;
};

export default Preload;
